export default __webpack_public_path__ + "static/media/Cyber_Forest_LE.826aaea9.jpg";